import { documentLinks } from '@content/documents';
import { navLinks } from '@content/navLinks';
import { Link } from 'react-router-dom';
import { useSiteContent } from '@/__lib/SiteContentProvider';
import { strings } from '@/i18n/strings';
import { Logo } from '@components/__shared/Logo/Logo';
import { SocialIcon } from '@components/__shared/SocialIcon/SocialIcon';
import styles from './Footer.module.scss';

export const Footer = () => {
	const { siteMeta } = useSiteContent();

	return (
		<footer className={styles.footer}>
			<div className={styles.top}>
				<div className={styles.brand}>
					<Logo size={40} onDark />
					<p className={styles.tagline}>{siteMeta.tagline}</p>
				</div>

				<nav className={styles.nav} aria-label={strings.nav.footerAriaLabel}>
					{navLinks.map(link => (
						<Link key={link.to} to={link.to}>
							{link.label}
						</Link>
					))}
				</nav>

				<div className={styles.contact}>
					<a href={`tel:${siteMeta.phone.replace(/\s+/g, '')}`}>{siteMeta.phone}</a>
					<a href={`mailto:${siteMeta.email}`}>{siteMeta.email}</a>
					<address>
						{siteMeta.addressLines.map((line, index) => (
							<span key={index}>{line}</span>
						))}
					</address>
				</div>

				<div className={styles.socials}>
					{siteMeta.socials.map(social => (
						<a key={social.url} href={social.url} target="_blank" rel="noreferrer">
							<SocialIcon label={social.label} className={styles.socialIcon} />
							{social.label}
						</a>
					))}
				</div>
			</div>

			<nav className={styles.docs} aria-label={strings.footer.documentsAriaLabel}>
				{documentLinks.map(doc => (
					<a key={doc.href} href={doc.href} target="_blank" rel="noreferrer">
						{doc.label}
					</a>
				))}
			</nav>

			<p className={styles.legal}>
				{siteMeta.legalName} | {strings.footer.companyId} {siteMeta.companyId} | {siteMeta.registeredSeat}
			</p>

			<p className={styles.copyright}>
				&copy; {new Date().getFullYear()} {siteMeta.businessName}. {strings.footer.rightsReserved}
			</p>
		</footer>
	);
};
